module.exports = __webpack_public_path__ + "static/Home_Feature_1-ac7751933aef0658949a7259946545de.jpg";